interface KeyPlayHeaderProps {
  playNumber: number
  title: string
  half: number
  turn: number
  opacity: number
  translateX: number
  rotate: number
  scale: number
  badgeScale: number
  badgeRotate: number
}

export function KeyPlayHeader({
  playNumber,
  title,
  half,
  turn,
  opacity,
  translateX,
  rotate,
  scale,
  badgeScale,
  badgeRotate,
}: KeyPlayHeaderProps) {
  return (
    <div
      className="inline-flex items-center gap-3 rounded-xl px-4 py-3 md:gap-4 md:px-5 md:py-3.5"
      style={{
        opacity,
        transform: `translateX(${translateX}px) rotate(${rotate}deg) scale(${scale})`,
        willChange: "opacity, transform",
        transformOrigin: "left center",
        background: "oklch(0.10 0.02 55 / 0.8)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        boxShadow:
          "0 4px 20px oklch(0 0 0 / 0.5), inset 0 0 0 1px oklch(0.30 0.04 55 / 0.4)",
      }}
    >
      {/* Play number badge — spins + bounces in */}
      <span
        className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full text-xl font-black"
        style={{
          background: "oklch(0.30 0.06 55)",
          color: "var(--neon-gold, var(--accent))",
          boxShadow:
            "0 0 20px oklch(0.80 0.30 145 / 0.35), 0 0 10px oklch(0.85 0.28 85 / 0.4), inset 0 0 8px oklch(0.85 0.28 85 / 0.1)",
          transform: `scale(${badgeScale}) rotate(${badgeRotate}deg)`,
          willChange: "transform",
        }}
      >
        {playNumber}
      </span>

      {/* Title */}
      <h3
        className="font-display min-w-0 flex-1 text-xl leading-tight font-black tracking-wide uppercase md:text-2xl"
        style={{
          color: "var(--foreground)",
          textShadow: "0 2px 4px oklch(0 0 0 / 0.5)",
        }}
      >
        {title}
      </h3>

      {/* Half/Turn pill */}
      <span
        className="flex-shrink-0 rounded-full px-2.5 py-1 text-[10px] font-black tracking-widest uppercase"
        style={{
          background: "oklch(0.25 0.04 55 / 0.8)",
          color: "var(--accent)",
        }}
      >
        {half === 3 ? "OT" : `H${half}`} T{turn}
      </span>
    </div>
  )
}
